var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-autocomplete',{attrs:{"items":_vm.items,"label":_vm.label || _vm.title,"item-text":_vm.itemText,"item-value":_vm.itemValue,"multiple":_vm.multiple},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }